import { render } from "./FacebookOverviewButton.vue?vue&type=template&id=e93971ac&scoped=true"
import script from "./FacebookOverviewButton.vue?vue&type=script&lang=js"
export * from "./FacebookOverviewButton.vue?vue&type=script&lang=js"

import "./FacebookOverviewButton.vue?vue&type=style&index=0&id=e93971ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e93971ac"]])

export default __exports__